/* eslint-disable react/no-danger */
import {css, view, createView} from '@sail/ui';
import {renderMarkdown} from '../../helpers/markdown';
import {secondaryLinkStyles} from '../../helpers/style-intents';

export const MarkdownText = createView(({body, ...props}: {body: string}) => {
  return (
    <view.div
      {...props}
      data-testid="markdown-text"
      className="uh-live-answers-v2-text-body"
      css={{
        stack: 'y',
        gap: 'medium',
        wordBreak: 'break-word',
      }}
      uses={[
        secondaryLinkStyles('.uh-live-answers-v2-text-body'),
        css.global({
          '.uh-live-answers-v2-text-body p': {
            marginY: 12,
          },
          '.uh-live-answers-v2-text-body p:first-of-type': {
            marginTop: 0,
          },
          '.uh-live-answers-v2-text-body p:last-of-type': {
            marginBottom: 0,
          },
          '.uh-live-answers-v2-text-body ol, .uh-live-answers-v2-text-body ul':
            {
              margin: 0,
              paddingLeft: 'medium',
            },
          '.uh-live-answers-v2-text-body li': {
            marginY: 12,
          },
          '.uh-live-answers-v2-text-body li:first-of-type': {
            marginTop: 0,
          },
          '.uh-live-answers-v2-text-body li:last-of-type': {
            marginBottom: 0,
          },
          '.uh-live-answers-v2-text-body li li:first-of-type, .uh-live-answers-v2-text-body li li:last-of-type':
            {
              marginY: 12,
            },

          '.uh-live-answers-v2-text-body li ol, .uh-live-answers-v2-text-body li ul':
            {
              marginLeft: 0,
            },
          '.uh-live-answers-v2-text-body li p': {
            marginY: 12,
          },
          '.uh-live-answers-v2-text-body li p:first-of-type, .uh-live-answers-v2-text-body li p:last-of-type':
            {
              marginY: 0,
            },
        }),
      ]}
      // eslint-disable-next-line react/no-danger
      // nosemgrep: no-react-dangerouslysetinnerhtml
      dangerouslySetInnerHTML={{__html: renderMarkdown(body)}}
    />
  );
});
